module.exports = __webpack_public_path__ + "img/18.0b486479.jpg";